module.exports = __webpack_public_path__ + "static/media/structure.49c72846.svg";